import React from 'react';
import { 
	BadgeIcon,
	BellIcon,
	MoneyIcon,
	ShieldIcon,
	TicketIcon,
	UnlockIcon
} from 'Components/Icons';
import { IAccountSettingCard } from 'Constants';
import { Icon } from '@chakra-ui/icons';
import { AiOutlineEye, AiOutlineSetting } from 'react-icons/ai';

export const myAccountSectionDetails: IAccountSettingCard[] = [
	{
		title: 'Which details can be edited?',
		icon: <UnlockIcon boxSize={5}/>,
		description: `You can edit any of the information shared at anytime. 
		We encourage you to keep things as up-to-date and accurate as possible. 
		From time-to-time we will launch verification challenges through which you will be able to earn extra points by confirming information shared with documentation.`,
		iconBgColor: '#FFF3DF'
	},
	{
		title: 'What info is shared with others?',
		icon: <BadgeIcon boxSize={5}/>,
		description: `You have full control over any information that is shared with Brands you interact with. 
		The minimum information shared when you interact with a given brand's campaign is Age, Sex and Location. 
		When connecting with a particular brand you are able to determine if anything further is shared and can control each piece of information and contact preferences on a granular level. 
		Furthermore you can change this setting anytime by managing your Loop with that Brand.`,
		iconBgColor: '#FFEEEC'
	},
	
];

export const loginAndSecurityDetails: IAccountSettingCard[] = [
	{
		title: 'Keeping your account secure',
		icon: <ShieldIcon boxSize={5}/>,
		description: 'Your security is of utmost importance to us at Loop and we will be continuously adding features to help keep your account secure and your information private.',
		iconBgColor: '#DDFFF0'
	},
];

export const preferenceDetails: IAccountSettingCard[] = [
	{
		title: 'Preferences help provide more context to the information you share.',
		icon: <Icon as={AiOutlineSetting} boxSize={5}/>,
		description: 'We\'ve come up with a set of questions to enable brands to draw better conclusions from your answers. The hope is, when approved to share with a particular brand, they are able to better contextualize your answers and work towards meeting your requirements better.',
		iconBgColor: '#F6F6F6'
	},
];

export const privacyAndSharingDetails: IAccountSettingCard[] = [
	{
		title: 'Curate what you share',
		icon: <Icon as={AiOutlineEye} boxSize={5}/>,
		description: 'Lorem ipsum dolor sit amet, consectetur adip iscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ulla mco laboris nisi ut aliquip ex ea commodo con sequat.',
		iconBgColor: '#DAF4FF'
	},
];

export const paymentAndPayoutDetails: IAccountSettingCard[] = [
	{
		title: 'Manage your payments',
		icon: <MoneyIcon boxSize={5}/>,
		description: 'Lorem ipsum dolor sit amet, consectetur adip iscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ulla mco laboris nisi ut aliquip ex ea commodo con sequat.',
		iconBgColor: '#E9F9FF'
	},
];

export const creditsAndCouponDetails: IAccountSettingCard[] = [
	{
		title: 'The more you refer, the more you earn',
		icon: <TicketIcon boxSize={5}/>,
		description: 'Lorem ipsum dolor sit amet, consectetur adip iscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ulla mco laboris nisi ut aliquip ex ea commodo con sequat.',
		iconBgColor: '#FFD7D7'
	},
];

export const notificationDetails: IAccountSettingCard[] = [
	{
		title: 'Control how messages is being sent to you',
		icon: <BellIcon boxSize={5}/>,
		description: 'Lorem ipsum dolor sit amet, consectetur adip iscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ulla mco laboris nisi ut aliquip ex ea commodo con sequat.',
		iconBgColor: '#FFEED1',
	},
];